export const mapHeader = () => {
  return {
    accept: "application/json",
  };
};
